import type {
  BatMetadataConfigEntry,
  FieldMetadataMessageDescriptorDef,
} from './common/types';
import { coreFields } from './common/commonFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';
import { currencyField } from './common/expenditureFields';
import {
  cloudServiceField,
  cloudVmInstanceTypeField,
} from './common/cloudFields';

const cloudSpendCurrencyQuantity: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Cloud spend',
    context: 'The spend on cloud services.',
  }),
  externalDescription: msg({
    message: 'The spend on cloud services.',
    context: 'Cloud spend',
  }),
};

export const cloudSpendMetadata = {
  displayName: msg({
    message: 'Cloud expenses',
    context: 'Activity data schema name for cloud expenses',
  }),
  fields: {
    ...coreFields,
    ...vendorFields,
    cloud_discount_rate: {
      displayName: msg({
        message: 'Cloud discount rate',
        context: 'The discount rate applied to the cloud expenditure.',
      }),
    },
    cloud_service: cloudServiceField,
    cloud_vm_instance_type: cloudVmInstanceTypeField,
    currency: currencyField,
    currency_quantity: cloudSpendCurrencyQuantity,
    // NOTE: quantity does not exist on the BAT but currency_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: cloudSpendCurrencyQuantity,
    has_cloud_discount: {
      displayName: msg({
        message: 'Has cloud discount',
        context: 'Indicator of whether the cloud expenditure is discounted.',
      }),
    },
    has_matching_cloud_compute_usage: {
      displayName: msg({
        message: 'Has matching cloud compute usage',
        context:
          'Indicator of whether the expenditure on cloud has matching usage.',
      }),
      externalDescription: msg({
        message:
          'Indicator of whether the expenditure on cloud has matching usage.',
        context: 'Has matching cloud compute usage',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
